import React from 'react';
const ExpertQuotes = () => {
  return <section className="py-16 md:py-24 bg-gradient-to-b from-cream-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Centered Gabor Maté Quote */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-white border-l-4 border-warm-400 p-8 md:p-12 rounded-r-xl shadow-lg">
            <p className="text-xl md:text-2xl text-gray-600 italic leading-relaxed mb-6">
              Gabor Maté identifies how societal pressure on women to be endlessly nurturing and self-sacrificing leads to chronic stress and disconnection from one's true self. He emphasizes this is not a personal failing but a physiological response to systemic gender oppression.
            </p>
            <div>
              <p className="text-sage-700 font-semibold text-lg">Gabor Maté, MD</p>
              <p className="text-sage-600 text-base">Trauma & Addiction Expert</p>
              <p className="text-sage-500 text-sm mt-2">Source: <span className="italic">When the Body Says No: The Cost of Hidden Stress</span></p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default ExpertQuotes;